import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X, Code, ExternalLink, Phone } from 'lucide-react';
export function PitchPopup() {
  const [isVisible, setIsVisible] = useState(false);
  const [hasSeen, setHasSeen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      if (hasSeen) return;
      const scrollPosition = window.scrollY + window.innerHeight;
      const documentHeight = document.documentElement.scrollHeight;
      if (scrollPosition > documentHeight * 0.5) {
        setIsVisible(true);
        setHasSeen(true);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [hasSeen]);
  return <AnimatePresence data-id="element-59">
      {isVisible && <motion.div initial={{
      opacity: 0,
      y: 50,
      scale: 0.9
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 20,
      scale: 0.9
    }} transition={{
      type: 'spring',
      damping: 25,
      stiffness: 300
    }} className="fixed bottom-6 right-6 z-50 max-w-sm w-[calc(100%-3rem)] bg-white rounded-2xl shadow-2xl border border-zinc-200 overflow-hidden" data-id="element-60">
          <div className="bg-zinc-950 p-4 flex items-center justify-between" data-id="element-61">
            <div className="flex items-center gap-2 text-white" data-id="element-62">
              <Code size={18} className="text-zinc-400" data-id="element-63" />
              <span className="font-bold text-sm tracking-wide" data-id="element-64">
                Пропозиція для власника
              </span>
            </div>
            <button onClick={() => setIsVisible(false)} className="text-zinc-500 hover:text-white transition-colors" data-id="element-65">
              <X size={20} data-id="element-66" />
            </button>
          </div>

          <div className="p-6" data-id="element-67">
            <p className="text-zinc-600 text-sm leading-relaxed mb-6 font-medium" data-id="element-68">
              Цей сайт ми можемо зробити для вас повністю під ключ, адаптувати
              під всі ваші потреби - вартість сайту під ключ всього лише{' '}
              <strong className="text-zinc-900 text-base font-extrabold" data-id="element-69">
                8 000 грн
              </strong>
              .
            </p>

            <div className="space-y-3" data-id="element-70">
              <a href="tel:+380508399309" className="flex items-center justify-center gap-2 w-full bg-zinc-100 text-zinc-900 py-3 rounded-xl text-sm font-bold hover:bg-zinc-200 transition-colors" data-id="element-71">
                <Phone size={16} data-id="element-72" />
                +38 050 839 93 09
              </a>
              <a href="https://jetly.agency/ua" target="_blank" rel="noopener noreferrer" className="flex items-center justify-center gap-2 w-full bg-zinc-900 text-white py-3 rounded-xl text-sm font-bold hover:bg-zinc-800 transition-colors shadow-md shadow-zinc-900/10" data-id="element-73">
                <ExternalLink size={16} data-id="element-74" />
                jetly.agency/ua
              </a>
            </div>
          </div>
        </motion.div>}
    </AnimatePresence>;
}